module.exports = {"653227100":"尼雅镇","653227200":"尼雅乡","653227201":"若克雅乡","653227202":"萨勒吾则克乡","653227203":"叶亦克乡","653227204":"安迪尔乡","653227205":"亚瓦通古孜乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653227.json
// module id = 2907
// module chunks = 0